import sanitizeHtml from 'sanitize-html';

const INLINE_TAGS = ['b', 'strong', 'i', 'em', 'u', 'sub', 'sup', 'span'];

export const sanitizeInlineHtml = (html: string): string => (
  sanitizeHtml(html, { allowedTags: INLINE_TAGS })
);
